import { render, staticRenderFns } from "./typeTable.vue?vue&type=template&id=d11766be&scoped=true&"
import script from "./typeTable.vue?vue&type=script&lang=js&"
export * from "./typeTable.vue?vue&type=script&lang=js&"
import style0 from "./typeTable.vue?vue&type=style&index=0&id=d11766be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d11766be",
  null
  
)

export default component.exports